import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProgramList } from './redux/actions/Actions';
import axiosinstance from '../api/axiosinstance';

const COURSES = [
  'Full Stack Development', 'Java Full Stack', 'MERN Stack Developer',
  'Python Full Stack', 'Data Science & AI', 'DevOps & Cloud Engineering',
  'UI/UX Design', 'Mobile App Development', 'Cybersecurity', 'Business Analytics',
];

const RobotSVG = () => (
  <svg width="90" height="104" viewBox="0 0 130 150" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="35" y="70" width="60" height="55" rx="10" fill="#1E3A5F" stroke="#3B82F6" strokeWidth="1.5"/>
    <rect x="38" y="30" width="54" height="44" rx="10" fill="#1E3A5F" stroke="#3B82F6" strokeWidth="1.5"/>
    <line x1="65" y1="30" x2="65" y2="16" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="65" cy="13" r="4" fill="#60A5FA"/>
    <circle cx="65" cy="13" r="2" fill="#BFDBFE"/>
    <ellipse cx="52" cy="50" rx="8" ry="8" fill="#0EA5E9"/>
    <ellipse cx="78" cy="50" rx="8" ry="8" fill="#0EA5E9"/>
    <ellipse cx="52" cy="50" rx="4" ry="4" fill="#1E40AF"/>
    <ellipse cx="78" cy="50" rx="4" ry="4" fill="#1E40AF"/>
    <ellipse cx="53" cy="49" rx="1.5" ry="1.5" fill="white"/>
    <ellipse cx="79" cy="49" rx="1.5" ry="1.5" fill="white"/>
    <rect x="50" y="64" width="30" height="5" rx="2.5" fill="#3B82F6"/>
    <rect x="54" y="65.5" width="5" height="2" rx="1" fill="#93C5FD"/>
    <rect x="61" y="65.5" width="5" height="2" rx="1" fill="#93C5FD"/>
    <rect x="68" y="65.5" width="5" height="2" rx="1" fill="#93C5FD"/>
    <rect x="47" y="80" width="36" height="25" rx="6" fill="#0F2744" stroke="#3B82F6" strokeWidth="1"/>
    <circle cx="55" cy="90" r="5" fill="#1D4ED8"/>
    <circle cx="55" cy="90" r="3" fill="#3B82F6"/>
    <rect x="64" y="85" width="12" height="2.5" rx="1.2" fill="#60A5FA"/>
    <rect x="64" y="90" width="9" height="2.5" rx="1.2" fill="#93C5FD"/>
    <rect x="64" y="95" width="11" height="2.5" rx="1.2" fill="#60A5FA"/>
    <rect x="12" y="72" width="20" height="10" rx="5" fill="#1E3A5F" stroke="#3B82F6" strokeWidth="1.5"/>
    <rect x="98" y="72" width="20" height="10" rx="5" fill="#1E3A5F" stroke="#3B82F6" strokeWidth="1.5"/>
    <circle cx="118" cy="68" r="6" fill="#1E3A5F" stroke="#3B82F6" strokeWidth="1.5"/>
    <rect x="115" y="58" width="6" height="10" rx="3" fill="#1E3A5F" stroke="#3B82F6" strokeWidth="1.2"/>
    <circle cx="12" cy="79" r="6" fill="#1E3A5F" stroke="#3B82F6" strokeWidth="1.5"/>
    <rect x="42" y="122" width="18" height="22" rx="7" fill="#1E3A5F" stroke="#3B82F6" strokeWidth="1.5"/>
    <rect x="70" y="122" width="18" height="22" rx="7" fill="#1E3A5F" stroke="#3B82F6" strokeWidth="1.5"/>
    <rect x="39" y="139" width="22" height="9" rx="4" fill="#1D4ED8"/>
    <rect x="68" y="139" width="22" height="9" rx="4" fill="#1D4ED8"/>
    <rect x="46" y="108" width="38" height="14" rx="4" fill="#2563EB"/>
    <text x="65" y="119" textAnchor="middle" fill="white" fontSize="8" fontWeight="bold" fontFamily="Arial">UPL</text>
    <ellipse cx="65" cy="148" rx="30" ry="5" fill="#3B82F6" fillOpacity="0.15"/>
  </svg>
);

const FEATURES = [
  {
    title: 'Industry-Relevant Programs',
    icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>,
  },
  {
    title: 'Expert Mentorship & Guidance',
    icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>,
  },
  {
    title: 'Live Projects & Real Experience',
    icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8"/><path d="M12 17v4"/><polyline points="9 10 12 13 15 10"/></svg>,
  },
  {
    title: 'Placement Support',
    icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/><line x1="12" y1="12" x2="12" y2="16"/><line x1="10" y1="14" x2="14" y2="14"/></svg>,
  },
];

/* ─────────────────────────────────────────────────────────────
   RequestCallback — works both as modal (isModal=true) and
   as a standalone page (default, visited via /request-callback)
───────────────────────────────────────────────────────────── */
const RequestCallback = ({ isModal = false, onClose, onSuccess, defaultProgram = '', defaultCourse = '' }) => {
  const dispatch  = useDispatch();
  const navigate  = useNavigate();
  const programs  = useSelector((s) => s.fetchAllPrograms.programs) || [];

  const [form, setForm]         = useState({ phone: '', program: '', programId: '', course: '' });
  const [errors, setErrors]     = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [courses, setCourses]   = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => { dispatch(fetchProgramList()); }, [dispatch]);

  useEffect(() => {
    if (defaultProgram && programs.length > 0 && !form.program) {
      const match = programs.find(p => p.program_name === defaultProgram);
      if (match) {
        setForm(p => ({ ...p, program: match.program_name }));
        axiosinstance.get(`/api/category/all/${match.program_id}`)
          .then(res => {
            if (Array.isArray(res.data)) {
              setCourses(res.data);
              if (defaultCourse) {
                const courseMatch = res.data.find(c => c.course_name === defaultCourse);
                if (courseMatch) setForm(p => ({ ...p, course: courseMatch.course_name }));
              }
            }
          })
          .catch(() => {});
      }
    }
  }, [defaultProgram, programs]);

  /* lock body scroll when open as modal */
  useEffect(() => {
    if (isModal) { document.body.style.overflow = 'hidden'; }
    return () => { document.body.style.overflow = ''; };
  }, [isModal]);

  const handleClose = () => {
    if (onClose) { onClose(); }
    else { navigate(-1); }
  };

  const validate = () => {
    const e = {};
    if (!/^\d{10}$/.test(form.phone.replace(/\s/g, ''))) e.phone   = '10-digit number required';
    if (!form.program)                                    e.program = 'Please select a program';
    if (!form.course)                                     e.course  = 'Please select a course';
    return e;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(p => ({ ...p, [name]: value }));
    setErrors(p => { const n = { ...p }; delete n[name]; return n; });

    if (name === 'program') {
      setForm(p => ({ ...p, program: value, course: '' }));
      setCourses([]);
      const selectedProg = programs.find(p => p.program_name === value);
      if (selectedProg) {
        axiosinstance.get(`/api/category/all/${selectedProg.program_id}`)
          .then(res => { if (Array.isArray(res.data)) setCourses(res.data); })
          .catch(() => {});
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const ve = validate();
    if (Object.keys(ve).length) { setErrors(ve); return; }

    // Save to backend (callback + enquiry)
    try {
      await axiosinstance.post('/api/callback', { phone: form.phone, program: form.program, course: form.course });
      await axiosinstance.post('/api/enquiries', {
        student_name: 'Enquiry - ' + form.phone,
        phone: form.phone,
        program: form.program,
        course: form.course,
        source: 'Website',
        status: 'New',
      });
    } catch (err) {
      console.error('Save failed:', err);
      // Still show success to user even if API fails
    }

    setSubmitted(true);
    if (onSuccess) onSuccess(form);
  };

  const card = (
    <>
      <style>{`
        #rc-card { width:100%; max-width:460px; border-radius:18px; overflow:hidden; box-shadow:0 28px 80px rgba(0,0,0,0.55); position:relative; }
        #rc-header { background:linear-gradient(135deg,#090F20 0%,#0D1B3E 55%,#162650 100%); padding:16px 20px 0; border-bottom:1px solid rgba(59,130,246,0.18); }
        #rc-close-btn { position:absolute; top:10px; right:12px; width:26px; height:26px; border-radius:50%; background:rgba(255,255,255,0.1); border:none; color:#94A3B8; font-size:13px; cursor:pointer; display:flex; align-items:center; justify-content:center; transition:background 0.2s; z-index:10; line-height:1; }
        #rc-close-btn:hover { background:rgba(255,255,255,0.22); color:#fff; }
        #rc-hero-row { display:flex; align-items:flex-end; justify-content:space-between; }
        #rc-hero-text { flex:1; padding-right:8px; padding-bottom:12px; }
        #rc-hero-title { font-size:17px; font-weight:800; color:#FFFFFF; line-height:1.3; margin:0 0 5px; letter-spacing:-0.02em; }
        #rc-hero-sub { font-size:11.5px; color:#94A3B8; line-height:1.5; margin:0; }
        #rc-features { display:grid; grid-template-columns:repeat(4,1fr); margin:0 -20px; border-top:1px solid rgba(59,130,246,0.13); }
        .rc-feat { padding:8px 6px; text-align:center; border-right:1px solid rgba(59,130,246,0.1); }
        .rc-feat:last-child { border-right:none; }
        .rc-feat-icon { display:flex; align-items:center; justify-content:center; width:30px; height:30px; border-radius:8px; background:rgba(37,99,235,0.14); margin:0 auto 5px; }
        .rc-feat-label { font-size:9px; color:#CBD5E1; font-weight:500; line-height:1.3; }
        #rc-form-wrap { background:#FFFFFF; padding:16px 20px; }
        .rc-field { margin-bottom:10px; }
        .rc-label { display:block; font-size:11px; font-weight:700; color:#374151; margin-bottom:4px; letter-spacing:0.02em; }
        .rc-req { color:#EF4444; }
        #rc-phone-row { display:flex; border:1.5px solid #E2E8F0; border-radius:9px; overflow:hidden; background:#F8FAFC; transition:border-color 0.2s; }
        #rc-phone-row:focus-within { border-color:#4F46E5; }
        #rc-phone-prefix { padding:0 12px; font-size:12px; font-weight:700; color:#374151; background:#F1F5F9; border-right:1px solid #E2E8F0; display:flex; align-items:center; white-space:nowrap; flex-shrink:0; }
        #rc-phone-input { flex:1; border:none; outline:none; padding:9px 12px; font-size:13px; color:#1E293B; background:transparent; font-family:'Inter','Segoe UI',sans-serif; width:100%; }
        .rc-select { width:100%; padding:9px 12px; border:1.5px solid #E2E8F0; border-radius:9px; font-size:13px; color:#1E293B; background:#F8FAFC; outline:none; cursor:pointer; font-family:'Inter','Segoe UI',sans-serif; appearance:none; background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%2364748B' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round' fill='none'/%3E%3C/svg%3E"); background-repeat:no-repeat; background-position:right 12px center; transition:border-color 0.2s; box-sizing:border-box; }
        .rc-select:focus { border-color:#4F46E5; }
        .rc-err { font-size:10px; color:#EF4444; font-weight:500; display:block; margin-top:2px; }
        #rc-submit { width:100%; padding:11px; background:linear-gradient(90deg,#6D28D9 0%,#4F46E5 50%,#2563EB 100%); color:#fff; border:none; border-radius:10px; font-size:13.5px; font-weight:700; cursor:pointer; margin-top:4px; transition:opacity 0.2s; display:flex; align-items:center; justify-content:center; gap:8px; font-family:'Inter','Segoe UI',sans-serif; }
        #rc-submit:hover { opacity:0.88; }
        #rc-privacy { display:flex; align-items:center; justify-content:center; gap:6px; margin-top:8px; font-size:11px; color:#94A3B8; }
        #rc-success { background:#fff; padding:40px 28px; text-align:center; }
        #rc-success-icon { width:64px; height:64px; border-radius:50%; background:linear-gradient(135deg,#EEF2FF,#DBEAFE); border:2px solid #C7D2FE; display:flex; align-items:center; justify-content:center; margin:0 auto 16px; }
        #rc-success-title { font-size:20px; font-weight:800; color:#0F172A; margin:0 0 9px; }
        #rc-success-text { font-size:13.5px; color:#475569; line-height:1.7; margin:0 0 24px; }
        #rc-success-btns { display:flex; gap:10px; justify-content:center; flex-wrap:wrap; }
        .rc-sbtn { padding:11px 24px; background:linear-gradient(90deg,#6D28D9,#2563EB); color:#fff; text-decoration:none; border-radius:9px; font-size:13.5px; font-weight:700; cursor:pointer; border:none; }
        .rc-sbtn-ghost { background:#F1F5F9 !important; color:#4F46E5 !important; border:1.5px solid #C7D2FE !important; text-decoration:none; padding:11px 24px; border-radius:9px; font-size:13.5px; font-weight:700; }
        @media(max-width:600px) {
          #rc-card { max-width:100%; border-radius:16px 16px 0 0; }
          #rc-features { grid-template-columns:repeat(2,1fr); }
          .rc-feat:nth-child(2){ border-right:none; }
          .rc-feat:nth-child(3),.rc-feat:nth-child(4){ border-top:1px solid rgba(59,130,246,0.1); }
          #rc-hero-title { font-size:15px !important; }
          #rc-form-wrap { padding:14px 16px !important; }
        }
      `}</style>

      <div id="rc-card">
        {/* Header */}
        <div id="rc-header">
          <button id="rc-close-btn" onClick={handleClose} aria-label="Close">✕</button>

          <div id="rc-hero-row">
            <div id="rc-hero-text">
              <h2 id="rc-hero-title">Take the First Step<br />Towards Your Future!</h2>
              <p id="rc-hero-sub">Fill in your details and our team will<br />connect with you shortly.</p>
            </div>
            <div style={{ flexShrink: 0 }}><RobotSVG /></div>
          </div>

          <div id="rc-features">
            {FEATURES.map(f => (
              <div className="rc-feat" key={f.title}>
                <div className="rc-feat-icon">{f.icon}</div>
                <div className="rc-feat-label">{f.title}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Form / Success */}
        {submitted ? (
          <div id="rc-success">
            <div id="rc-success-icon">
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#4F46E5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
            </div>
            <h3 id="rc-success-title">You're All Set!</h3>
            <p id="rc-success-text">
              Our team will call you on <strong>+91 {form.phone}</strong> shortly.<br />
              We'll help you get started with <strong>{form.program}</strong>.
            </p>
            <div id="rc-success-btns">
              <button className="rc-sbtn" onClick={handleClose}>Close</button>
              <Link to="/programs" className="rc-sbtn-ghost" onClick={handleClose}>View Programs</Link>
            </div>
          </div>
        ) : (
          <div id="rc-form-wrap">
            <form onSubmit={handleSubmit}>

              <div className="rc-field">
                <label className="rc-label">Mobile Number <span className="rc-req">*</span></label>
                <div id="rc-phone-row">
                  <span id="rc-phone-prefix">+91</span>
                  <input
                    id="rc-phone-input"
                    name="phone"
                    type="tel"
                    value={form.phone}
                    onChange={handleChange}
                    placeholder="Enter your 10 digit mobile number"
                    maxLength={10}
                  />
                </div>
                {errors.phone && <span className="rc-err">{errors.phone}</span>}
              </div>

              <div className="rc-field">
                <label className="rc-label">Select Program <span className="rc-req">*</span></label>
                <select
                  name="program"
                  value={form.program}
                  onChange={handleChange}
                  className="rc-select"
                  style={errors.program ? { borderColor: '#FCA5A5' } : {}}
                >
                  <option value="">-- Select Program --</option>
                  {programs.length > 0
                    ? programs.map(p => <option key={p.program_id} value={p.program_name}>{p.program_name}</option>)
                    : ['Coding Bootcamp', 'Developer Full Time Program', 'Java Full Stack Developer', 'MERN Stack Developer'].map(p => (
                        <option key={p} value={p}>{p}</option>
                      ))
                  }
                </select>
                {errors.program && <span className="rc-err">{errors.program}</span>}
              </div>

              <div className="rc-field">
                <label className="rc-label">Select Course <span className="rc-req">*</span></label>
                <select
                  name="course"
                  value={form.course}
                  onChange={handleChange}
                  className="rc-select"
                  style={errors.course ? { borderColor: '#FCA5A5' } : {}}
                  disabled={!form.program}
                >
                  <option value="">{form.program ? '-- Select Course --' : '-- Select a program first --'}</option>
                  {courses.map(c => <option key={c.course_id} value={c.course_name}>{c.course_name}</option>)}
                </select>
                {errors.course && <span className="rc-err">{errors.course}</span>}
              </div>

              <button type="submit" id="rc-submit">
                Submit &amp; Get Started
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
                </svg>
              </button>

              <div id="rc-privacy">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
                Your information is safe with us. We respect your privacy.
              </div>
            </form>
          </div>
        )}
      </div>
    </>
  );

  /* ── Render as modal overlay or standalone page ── */
  if (isModal) {
    return (
      <div
        style={{
          position: 'fixed', inset: 0, zIndex: 9999,
          background: 'rgba(4,9,22,0.82)',
          backdropFilter: 'blur(4px)',
          display: 'flex',
          alignItems: isMobile ? 'flex-end' : 'center',
          justifyContent: 'center',
          padding: isMobile ? '0' : '16px',
          overflowY: 'auto',
          fontFamily: "'Inter','Segoe UI',sans-serif",
        }}
        onMouseDown={(e) => { if (e.target === e.currentTarget) handleClose(); }}
      >
        {card}
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg,#060D1F 0%,#0A1628 50%,#0D1E3D 100%)',
      padding: '40px 16px', fontFamily: "'Inter','Segoe UI',sans-serif",
    }}>
      {card}
    </div>
  );
};

export default RequestCallback;
